import { render, staticRenderFns } from "./SyncCurrentStandard.vue?vue&type=template&id=dacaa3ca&scoped=true&"
import script from "./SyncCurrentStandard.vue?vue&type=script&lang=js&"
export * from "./SyncCurrentStandard.vue?vue&type=script&lang=js&"
import style0 from "./SyncCurrentStandard.vue?vue&type=style&index=0&id=dacaa3ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacaa3ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VRow,VSnackbar,VToolbar,VToolbarTitle})
